module.exports = __webpack_public_path__ + "assets/usa.6329fd3b824dbee2e9669955d7395184.svg?";